// extracted by mini-css-extract-plugin
module.exports = {"root":"ProgressSpinner-m__root___AQMs-","icon":"ProgressSpinner-m__icon___8sDCw","SPIN":"ProgressSpinner-m__SPIN___EAN7S"};